<template>
  <v-menu
    :close-on-content-click='false'
    offset-x
    left
    nudge-left='30px'
    transition='slide-x-reverse-transition'
    :value='showSearch'
  >
    <template v-slot:activator='{ on }'>
      <v-icon v-on='on' @click='openSearch' large>mdi-magnify</v-icon>
    </template>
    <v-card width='450' class='px-3 pt-2'>
      <v-text-field
        v-model='search'
        prepend-icon='mdi-magnify'
        label='Search Clients (by first or last name)'
        :loading='searching'
        :hint='searchStatus'
        persistent-hint
        ref='clientSearch'
        append-icon='mdi-close'
        @click:append='clearSearch'
      >
      </v-text-field>
      <v-list>
        <v-list-item v-for='r in results' :key='r.id' @click='openItem(r)'>
          <v-list-item-content>
            <v-list-item-subtitle>
              {{ r.name_display }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item v-if='!searching && search.trim().length > 2 && results.length === 0'>
          <v-list-item-content>
            <v-list-item-subtitle class='grey--text'>
              No clients found for "{{ search.trim() }}"
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script>
import clientsAPI from '@/modules/clients/api/clients'
import _ from 'lodash'

export default {
  name: 'client-search',
  data: () => ({
    searching: false,
    showSearch: false,
    search: '',
    searchStatus: '',
    results: []
  }),
  watch: {
    'search' () {
      const length = this.search.trim().length
      if (length > 2) {
        this.executeSearch()
      } else if (length > 0) {
        const remaining = 3 - length
        this.searchStatus = `Type ${remaining} more letter${remaining > 1 ? 's' : ''} to search`
        this.executeSearch(true)
      } else {
        this.searchStatus = ''
        this.results = []
      }
    }
  },
  methods: {
    executeSearch: _.debounce(function (exact) {
      this.searching = true
      if (!exact) {
        this.searchStatus = `Searching for "${this.search.trim()}"...`
      }
      this.searchAPI(exact)
    }, 300),

    async searchAPI (exact) {
      if (this.search === '') {
        this.results = []
      } else {
          this.results = await clientsAPI.clientSearch(this.search.trim(), null, exact)
      }
      if (!exact) {
        this.searchStatus = ''
      }
      this.searching = false
    },
    openItem (result) {
      this.$router.push({ name: 'ClientOverview', params: { id: result.id }})
      this.showSearch = false
      this.clearSearch()
    },
    clearSearch () {
      this.search = ''
      this.results = []
    },
    openSearch () {
      this.showSearch = true
      setTimeout(() => {
        this.$refs.clientSearch.focus()
      }, 100)
    }
  },
  components: {

  }
}
</script>